<template>
<div class="columns">

    <div class="column is-two-forth">
        <div class="field">
            <label class="label">Group Name</label>
            <div class="control">
                <input class="input" type="text" placeholder="e.g Fatonah" v-model="name">
            </div>
        </div>
    </div>

    <div class="column is-one-forth">
        <div class="field">
            <label class="label">Group Teachers</label>
            <div class="control">
                <v-select multiple v-model="teachers" :options="options" label="firstName" key="_id"></v-select>
            </div>
        </div>
    </div>

    <div class="column is-one-forth">
        <div class="field">
            <label class="label">Status</label>
            <div class="control">
                <label class="radio">
                    <input type="radio" :name="newStatus" v-model="newStatus" value="1" checked>
                    Active
                </label>
                <label class="radio">
                    <input type="radio" :name="newStatus" v-model="newStatus" value="0">
                    Inactive
                </label>
            </div>
        </div>
    </div>

    <div class="column is-one-fifth">
        <div class="field">
            <label class="label">&nbsp;</label>
            <div class='ui two buttons'>
                <button class='button is-primary' v-on:click="sendForm()">
                    Create
                </button>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            input: {},
            teachers: '',
            name: '',
            newStatus: "1",
            // options: [{label: 'foo', value: 'FOO'},{label: 'bar', value: 'BAR'},'baz'],
            options: [],

            result: "",
            errors: []
        };
    },
    beforeMount() {
    },
    created() {
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        axios.defaults.responseType = 'json'
        axios.post(process.env.MY_URL + '/api/teachers/list', {
                params: {
                    email: localStorage.getItem('email'),
                    sessionID: localStorage.getItem('sessionID')
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                this.options = response.data
            })
            .catch(e => {
                this.errors.push(e)
                console.log("Error: " + e)
            })
    },
    methods: {
        sendForm() {
            console.log("imini 78" + this.name)
            if (this.name.length > 0) {
                if ((this.newStatus == "1") || (this.newStatus == "0")){
                    const name = this.name;
                    this.$emit('create-kumpulan', {
                        name,
                        done: false,
                    });

                    this.input.email = localStorage.getItem('email')
                    this.input.sessionID = localStorage.getItem('sessionID')
                    this.input.name = this.name
                    this.input.teachers = this.teachers
                    this.input.status = this.newStatus

                    axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                    axios.post(process.env.MY_URL + '/api/group/add', this.input)
                    
                        .then(response => {
                            if (response.data.success == false){
                                Toast.open({
                                    message: 'Error: ' + response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }else{
                                Toast.open({
                                    message: 'Successfully added new group',
                                    type: 'is-success', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                                this.$parent.getData()
                            }

                            this.name = '';
                            this.teachers = '';
                            this.status = 1;
                        })
                        .catch(e => {
                            console.log("error")
                            console.log(e.response)
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })

                                console.log("salah login")
                                this.errors.push("Invalid login")
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                                this.errors.push(e)
                            }
                        })
                }else{
                    alert("Please select the status of the group");
                }
            } else {
                alert("Please enter the group name");
            }
        },
    }
};
</script>
<style lang="css">
.tag.valid {
  background-color: #04B404;
  font-size: 10px;
  display: inline !important;
}

.tag.custom-class {
  background-color: #fff;
  color: rgba(100 ,100, 100, 1);
  font-weight: bold;
  text-transform: uppercase;
  box-shadow: 2px 2px 0px 0px rgba(100, 100, 100, 1);
  /* margin-right: 4px; */
  border: 1px solid rgba(100, 100, 100, 1);
  border-radius: 0px;
  font-size: 10px;
}
.icon-close{
    display: inline;
}
.tag.no-numbers {
  background-color: #FE9A2E;
}

.duplicate {
  text-decoration: line-through;
}

.new-tag-input.invalid, .item.invalid {
  color: #e54d42;
}

.new-tag-input.no-numbers, .item.no-numbers {
  color: #FE9A2E;
}

/* .tag:after {
  transition: transform .2s;
  position: absolute;
  content: '';
  height: 2px;
  width: 108%;
  left: -4%;
  top: calc(50% - 1px);
  background-color: #000;
  transform: scaleX(0);
}

.deletion-mark :after {
  transform: scaleX(1);
} */
</style>



// WEBPACK FOOTER //
// src/components/Database/BehaviourCategory/DataCreate.vue